const userpermission = {
  getall: 'userpermission/getall',
  getuserpermission: 'userpermission/get',
}
export default userpermission
